import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeAchievement = () => {
  const [AchievementTopUser, setAchievementTopUser] = useState([]);
  const [AchievementUser, setAchievementUser] = useState([]);
  const navigate = useNavigate();

  // achievement top 
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getachievementtop");
      setAchievementTopUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getachievement");
      setAchievementUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteachievement/${userId}`);

      setAchievementUser(
        (prevUsers) => prevUsers.filter((user) => user.id !== userId) 
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Achievement");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
        {AchievementTopUser.map((user) => {
            
            return (
              <div key={user.id}>
                {" "}
                <h3>
                  {user.title}{" "}
                  <Link to={`/Achievement-top-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.para }}></p>
              </div>
            );
          })}
{/* 
          <Link to="/Achievement-add">
            <button className="Banner-button">Add</button>
          </Link> */}

              <div  className="row">
          {AchievementUser.map((user) => {
            
            return (
                <div key={user.id} className="col-lg-6 col-md-6 col-sm-12">
                <h3>
                  {user.count}{" "}
                  <Link to={`/Achievement-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-sec"></i>
                  </Link>
                  {/* <span onClick={() => deleteUser(user.id)}>
                    {" "}
                    <i
                      title="Delete"
                      className="fa-solid fa-trash-can action-sec"
                      style={{ color: "red" }}
                    ></i>
                  </span> */}
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.description }}></p>
                </div>
            );
          })}
              </div>
        </div>
      </div>
    </div>
  );
};

export const HomeAchievementEdit = () => {
    const [Achievementuser, setAchievementUser] = useState({
      count: "",
      description: "",
    });
  
    const { id } = useParams();
    const navigate = useNavigate();
  
    // ✅ Handle input change
    const changeHandler = (e) => {
      const { name, value } = e.target;
      setAchievementUser({ ...Achievementuser, [name]: value });
    };
  
    // ✅ Fetch Achievement data
    const fetchAchievementData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneachievement/${id}`
        );
        if (response.data.success) {
          setAchievementUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching Achievement data!", error);
        toast.error("Failed to load Achievement data.");
      }
    };
  
    useEffect(() => {
      fetchAchievementData();
    }, [id]);
  
    // ✅ Submit form data
    const submitForm = async (e) => {
      e.preventDefault();
  
      const updatedData = {
        count: Achievementuser.count,
        description: Achievementuser.description
      };
  
      try {
        const response = await axios.put(
          `https://admin.gosaviadvanceddentalclinic.com/api/updateachievement/${id}`,
          updatedData,
          { headers: { "Content-Type": "application/json" } }
        );
  
        if (response.data.success) {
          setAchievementUser(updatedData);
          toast.success("Data updated successfully!");
          navigate("/Achievement");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("There was an error updating the Achievement!", error);
        toast.error("Failed to update Achievement.");
      }
    };
  
    return (
      <div
        className="modal fade show"
        id="update_heading"
        tabIndex={-1}
        style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
        aria-modal="true"
      >
        <div className="modal-dialog">
          <form onSubmit={submitForm}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit</h5>
                <Link to="/Achievement">
                  <button type="button" className="close">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-xmark"></i>
                    </span>
                  </button>
                </Link>
              </div>
  
              <div className="modal-body">
                <div className="form-group">
                  <label>Count</label>
                  <input
                    type="text"
                    value={Achievementuser.count}
                    onChange={changeHandler}
                    className="form-control"
                    name="count"
                    required
                  />
                  <br/>
                </div>
  
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={Achievementuser.description}
                    onChange={changeHandler}
                    className="form-control"
                    name="description"
                    required
                  />
                  <br/>
                </div>
              </div>
  
              <div className="modal-footer">
                <Link to="/Achievement">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </Link>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };
  
export const AchievementAdd = () => {
  const [AchievementData, setAchievementData] = useState({
    count: "",
    description: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setAchievementData((prev) => ({ ...prev, [name]: value }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!AchievementData.count || !AchievementData.description) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "https://admin.gosaviadvanceddentalclinic.com/api/createachievement",
        AchievementData
      );
      toast.success("Achievement added successfully!");
      navigate("/Achievement"); // Redirect after success
    } catch (error) {
      console.error("Error adding Achievement:", error);
      toast.error("Failed to add Achievement!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12"/>
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
      <div className="add-banner">
        <Link to="/Achievement"> <i className="fa-solid fa-xmark"></i></Link>
        <h3>Add Achievement Data</h3>
        <form className="row" onSubmit={submitForm}>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="count">count</label>
            <input
              type="text"
              onChange={inputHandler}
              value={AchievementData.count}
              id="count"
              name="count"
              placeholder="Enter count"
            />
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 inputform">
            <label htmlFor="description">Description</label>
            <textarea
              onChange={inputHandler}
              value={AchievementData.description}
              id="description"
              name="description"
              placeholder="Enter Description"
              rows="2"
            ></textarea>
          </div>
          <div className="mobilesubmitform">
            <button type="submit">Add Data</button>
          </div>
        </form>
      </div>
      </div>
      </div>
    </div>
  );
};


export const HomeAchievementTopEdit = () => {
  const [Achievementuser, setAchievementUser] = useState({
    title: "",
    para: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  // ✅ Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setAchievementUser({ ...Achievementuser, [name]: value });
  };

  // ✅ Fetch Achievement data
  const fetchAchievementData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getoneachievementtop/${id}`
      );
      if (response.data.success) {
        setAchievementUser(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Achievement data!", error);
      toast.error("Failed to load Achievement data.");
    }
  };

  useEffect(() => {
    fetchAchievementData();
  }, [id]);

  // ✅ Submit form data
  const submitForm = async (e) => {
    e.preventDefault();

    const updatedData = {
      title: Achievementuser.title,
      para: Achievementuser.para
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updateachievementtop/${id}`,
        updatedData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setAchievementUser(updatedData);
        toast.success("Data updated successfully!");
        navigate("/Achievement");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error updating the Achievement!", error);
      toast.error("Failed to update Achievement.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Achievement">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Achievementuser.title}
                  onChange={changeHandler}
                  className="form-control"
                  name="title"
                  required
                />
                <br/>
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  value={Achievementuser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  required
                />
                <br/>
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Achievement">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
